import {
  Directive,
  ElementRef,
  input,
  OnDestroy,
  inject,
  effect,
} from '@angular/core';

import { FocusOutsideDirective } from './focus-outside.directive';

@Directive({
  selector: '[pluginsFocusContainer]',
})
export class FocusContainerDirective implements OnDestroy {
  readonly focusOutsideDirectiveRef = input<FocusOutsideDirective>();

  private readonly elt = inject<ElementRef<HTMLElement>>(ElementRef);

  private readonly containerEffect = effect(() => {
    this.focusOutsideDirectiveRef()?.addContainer(this.elt.nativeElement);
  });

  ngOnDestroy(): void {
    this.focusOutsideDirectiveRef()?.removeContainer();
  }
}
